<template>
  <div class="body-container-activity border-container" v-if="session">
    <div class="learn-container p-0">
      <div id="videos">
        <Publisher :session="session" @publisherCreated="publisherCreated" @error="errorHandler"></Publisher>
        <div id="subscriber">
          <Subscriber v-if="stream" @error="errorHandler" @subscriberCreated="subscriberCreated" @subscriberConnected="subscriberConnected" :stream="stream" :session="session"></Subscriber>
        </div>

        <div class="row video-calling-wrapper d-flex align-items-center justify-content-center">
          <div class="col-lg-4"></div>
          <div class="col-lg-3 col-sm-12 col-md-4 d-flex align-items-center justify-content-between margin-5">
            <span class="text-danger">{{ timespent }}</span>
            <span v-if="controls.recording" class="cursor_pointer recording-icon"><img src="static/img/participant-portal/record.svg" height="20px" title="Recording..."/></span>
            <span class="cursor_pointer" @click="rejectCall"><i class="fa fa-phone text-danger fs-20" aria-hidden="true" style="transform: rotate(135deg);"></i></span>
            <span v-if="controls.speaker" class="cursor_pointer" @click="toggleSpeaker"><i class="fa fa-microphone text-white fs-20" aria-hidden="true"></i></span>
            <span v-else class="cursor_pointer" @click="toggleSpeaker"><i class="fa fa-microphone-slash text-white fs-20" aria-hidden="true"></i></span>
            <span v-if="controls.audio" class="cursor_pointer" @click="toggleAudio"><i class="fa fa-volume-up text-white fs-20" aria-hidden="true"></i></span>
            <span v-else class="cursor_pointer" @click="toggleAudio"><i class="fa fa-volume-off text-white fs-20" aria-hidden="true"></i></span>
            <span v-if="controls.video" class="cursor_pointer" @click="toggleVideo"><i class="fa fa-video-camera text-white fs-20" aria-hidden="true"></i></span>
            <span v-else class="cursor_pointer" @click="toggleVideo"><i class="fa fa-ban text-white fs-20"></i></span>
          </div>
          <div class="col-lg-5 col-sm-12 col-md-4 d-flex align-items-center justify-content-end margin-5">
            <button class="btn btn-tele-banner-white btn-tele-activities" @click.prevent="goToActivities()">
              Go to Activities
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade telehealth-modal" data-backdrop="false" id="recordCallModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <p class="pt-60 text-center telehealth-name-text m-0">
            This video call will be recorded with your acceptance.
          </p>
          <button @click="recordingRequestAccepted" class="btn btn-submit mt-70">
            Allow
          </button>
          <p @click="recordingRequestRejected" class="text-center cursor_pointer pt-24 pb-24 m-0 tele-sub-text">
            Don't Allow
          </p>
        </div>
      </div>
    </div>
    <!-- Modal -->
  </div>
</template>

<script>
import moment from "moment";
import OT from "@opentok/client";
import { mapGetters } from "vuex";
import $ from "jquery";
import Publisher from "@/components/participant-portal/telehealth/publisher.vue";
import Subscriber from "@/components/participant-portal/telehealth/subscriber.vue";
import { Widget, Telehealth, ParticipantPortal } from "@/components/services/participant-service";
export default {
  name: "telehealth-video-call",
  components: { Publisher, Subscriber },
  props: ["lang", "activity", "appointmentId"],
  data() {
    return {
      widget: new Widget(),
      telehealth: new Telehealth(),
      portal: new ParticipantPortal(),
      localAppointmentId: this.appointmentId,
      stream: null,
      session: null,
      publisher: null,
      subscriber: null,
      timespent: "0:00",

      controls: {
        video: true,
        audio: true,
        speaker: true,
        timer: false,
        recording: false
      },

      videoOptions: {
        insertMode: "append",
        width: "100%",
        height: "100%",
        style: {
          buttonDisplayMode: "on",
          nameDisplayMode: "on",
          backgroundImageURI: "",
          audioBlockedDisplayMode: "off"
        }
      }
    };
  },
  computed: {
    ...mapGetters(["participant"]),
    getSession() {
      return this.$store.getters.getParticipantTelehealthVideoCallDetails;
    }
  },
  watch: {
    activity(val) {
      if (val !== null) {
        this.options = this.telehealth.getVisitTypes(val.visitType);
      }
    },
    appointmentId(val) {
      this.localAppointmentId = val;
      this.startVideoCall();
      this.$emit("windowVisibility", true);
    }
  },
  mounted() {},
  created() {
    if (this.getSession) {
      this.startVideoCall();
    }
  },
  methods: {
    startVideoCall() {
      const that = this;
      if (this.session) {
        this.$emit("windowVisibility", true);
        return;
      }
      this.session = OT.initSession(this.getSession.apiKey, this.getSession.sessionId, { mediaMode: "routed" });
      this.session.on("streamDestroyed", function() {
        that.controls.timer = false;
        that.disconnect();
        const message = that.widget.translate("call_ended", "Call ended.");
        if (message) {
          that.$toastr.success(message);
        }
      });
      this.session.on("signal", event => {
        switch (event.data) {
          case "recording_requested":
            this.recordingRequested(event);
            break;
          case "recording_start":
            that.controls.recording = true;
            this.$toastr.success(this.widget.translate("recording_label_started", "Recording started"));
            break;
          case "recording_stopped":
          case "recording_timeout":
            that.controls.recording = false;
            this.$toastr.success(this.widget.translate("recording_label_ended", "Recording ended"));
            break;
        }
      });
      this.session.on("streamCreated", function(event) {
        that.stream = event.stream;
        that.controls.timer = true;
        that.startTimer();
      });
      this.session.on("streamDestroyed", () => {
        that.stream = null;
        that.controls.timer = false;
      });
      this.session.connect(this.getSession.token, () => {});
    },
    startTimer() {
      const that = this;
      let timespent = 0;
      setInterval(function() {
        that.timespent = moment()
          .hour(0)
          .minute(0)
          .second(timespent++)
          .format("m:ss");
      }, 1000);
    },
    recordingRequested() {
      $("#recordCallModal").modal("show");
    },
    sendSignal(data, onSuccess = null, onError = null) {
      this.session.signal(
        {
          type: "signal_type",
          data: data
        },
        function(error) {
          if (error) {
            onError();
          } else {
            onSuccess();
          }
        }
      );
    },
    recordingRequestAccepted() {
      this.sendSignal("recording_accepted", () => {
        $("#recordCallModal").modal("hide");
      });
    },
    recordingRequestRejected() {
      this.sendSignal("recording_denied", () => {
        $("#recordCallModal").modal("hide");
      });
    },
    subscriberCreated(subscriber) {
      this.subscriber = subscriber;
    },
    subscriberConnected(subscriber) {
      this.subscriber = subscriber;
    },
    goToActivities() {
      this.$emit("windowVisibility", false);
      this.getSession.hidden = true;
      this.$root.$emit("BannerForceUpdate");
      if (this.$route.name != "participants-portal-activities" && this.$route.name != "participants-portal-activity-list") {
        this.$router.push({
          name: "participants-portal-activities",
          params: { studyId: this.$route.params.studyId }
        });
      }
    },
    initCallSession() {},
    disconnect() {
      const message = this.widget.translate("call_ended", "Call ended.");
      if (message) {
        this.$toastr.success(message);
      }
      this.session.disconnect();
      this.session = null;
      this.$emit("windowVisibility", false);
      this.$store.dispatch("setParticipantsTelehealthSession", null);
      this.$router.push({
        name: "participants-portal-activities",
        params: { studyId: this.$route.params.studyId }
      });
    },
    toggleSpeaker() {
      this.controls.speaker = !this.controls.speaker;
      if (this.controls.speaker) {
        OT.unblockAudio();
      }
    },
    toggleAudio() {
      this.controls.audio = !this.controls.audio;
      this.publisher.publishAudio(this.controls.audio);
    },
    toggleVideo() {
      this.controls.video = !this.controls.video;
      this.publisher.publishVideo(this.controls.video);
    },
    errorHandler() {
      const message = this.widget.translate("please_enable_camera_and_microphone_permissions", "Please enable Camera and Microphone permissions.");
      if (message) {
        this.$toastr.success(message);
      }
      this.$router.push({
        name: "participants-portal-activities",
        params: { studyId: this.$route.params.studyId }
      });
    },
    publisherCreated(publisher) {
      this.publisher = publisher;
    },
    rejectCall() {
      const that = this;
      this.$api
        .rejectParticipantVideoCall({
          participantId: this.participant.pid,
          id: this.localAppointmentId
        })
        .then(
          () => {
            that.disconnect();
          },
          () => {
            that.disconnect();
          }
        );
    }
  }
};
</script>
<style scoped>
#videos {
  position: relative;
  height: 80vh;
}
#publisher {
  height: calc(100vh - 200px);
}
#subscriber {
  background-color: black;
  position: absolute;
  height: 100%;
  width: 100%;
}
.subscriber {
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
  z-index: 9;
}
.publisher {
  width: 150px !important;
  height: 200px !important;
  right: 25px;
  bottom: 65px;
  position: absolute;
  z-index: 99;
}
.video-calling-wrapper {
  bottom: 0;
  position: absolute;
  width: 100%;
  min-height: 45px;
  background-color: #000;
  z-index: 9;
}

.video-calling-wrapper .btn-tele-banner-white {
  width: auto;
  margin: auto 0;
}
.btn-tele-activities {
  height: 36px;
  padding: 7px 55px;
  border-radius: 6px;
  color: #ffffff;
  font-size: 14px;
  letter-spacing: 0.18px;
  background-color: #48bf94;
}
#teleVideoCallingModal .modal-content {
  padding: 60px 100px 24px;
}
#teleVideoCallingModal .btn-tele-video-allow {
  width: 100%;
  height: 50px;
  font-size: 17px;
  font-weight: 500;
  margin: 72px 0 24px;
  border-radius: 10px;
  color: #ffffff;
  background-color: #83c6a8;
}
@media (min-width: 576px) {
  #teleVideoCallingModal .modal-dialog {
    max-width: 556px !important;
    margin: 1.75rem auto;
  }
}

.telehealth-modal .modal-content {
  padding: 0 105px;
}
.telehealth-name-text {
  font-size: 24px;
  line-height: 1.17;
  letter-spacing: 0.35px;
  text-align: center;
  color: #4a4a4a;
}
.tele-sub-text {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.32px;
  text-align: center;
  color: #4c6473;
}
.btn-goto-activities {
  width: 258.2px;
  height: 36px;
  margin: 0 0 0 182px;
  padding: 6px 0.2px 6px 0;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  background-color: #4db6ac;
  line-height: 1.71;
  letter-spacing: 0.18px;
  text-align: center;
  color: #ffffff;
}
.video-calling-wrapper .recording-icon img {
  background-color: #ffffff;
  border-radius: 5px;
  cursor: auto;
}
</style>
